/* eslint-disable max-len */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LOCALES } from 'src/interfaces/i18n.types';
import { loadLocale } from 'src/utils/i18n.utils';

// Initialize with minimal resources - locales will be loaded dynamically
export const resources = {};

// Load default locale on initialization
const initializeI18n = async () => {
  // Load English translations as default/fallback
  const englishTranslations = await loadLocale(LOCALES.EN);

  i18n.use(initReactI18next).init({
    resources: {
      [LOCALES.EN]: {
        translation: englishTranslations,
      },
    },
    lng: LOCALES.EN,
    fallbackLng: LOCALES.EN,
    appendNamespaceToCIMode: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
};

// Initialize i18n
initializeI18n().catch((error) => {
  console.warn('Failed to initialize i18n:', error);
  // Fallback initialization with minimal config
  i18n.use(initReactI18next).init({
    resources: {},
    lng: LOCALES.EN,
    fallbackLng: LOCALES.EN,
    interpolation: {
      escapeValue: false,
    },
  });
});

export default i18n;
